import { useCallback, useSyncExternalStore } from 'react';

export const MOBILE_MEDIA_QUERY = '(max-width: 767px)';
export const TABLET_MEDIA_QUERY = '(min-width: 768px) and (max-width: 1023px)';

function getMediaQueryList(query: string): MediaQueryList | null {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function')
    return null;
  return window.matchMedia(query);
}

/**
 * Whether `query` matches, correct already on the first render and updated on
 * resize/rotation. `false` where `window.matchMedia` does not exist.
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const list = getMediaQueryList(query);
      if (!list) return () => {};
      list.addEventListener('change', onChange);
      return () => list.removeEventListener('change', onChange);
    },
    [query]
  );

  return useSyncExternalStore(
    subscribe,
    () => getMediaQueryList(query)?.matches ?? false,
    () => false
  );
}

/** < 768px (Tailwind `max-md:`). */
export function useIsMobile(): boolean {
  return useMediaQuery(MOBILE_MEDIA_QUERY);
}

/** 768–1023px (sidebar rail). */
export function useIsTablet(): boolean {
  return useMediaQuery(TABLET_MEDIA_QUERY);
}
